import { render } from "./Navbar.vue?vue&type=template&id=6ff8d63e&scoped=true&ts=true"
import script from "./Navbar.vue?vue&type=script&lang=ts"
export * from "./Navbar.vue?vue&type=script&lang=ts"

import "./Navbar.vue?vue&type=style&index=0&id=6ff8d63e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ff8d63e"]])

export default __exports__